import type { Change } from 'modules/employees/pages/EditInBulk/types'

const cloneChangeWithProperty = (change: Change, key: keyof Change) => {
  const newChange: Change = {
    [key]: change[key],
  }

  return newChange
}

export default cloneChangeWithProperty
